import { devError } from '../utils/devLogger';
import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebase';
import LearnerMobileNav from './LearnerMobileNav';

const LearnerNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/login');
    } catch (error) {
      devError('Failed to log out', error);
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Desktop Navbar - hidden on mobile */}
      <Navbar
        variant="dark"
        expand="lg"
        sticky="top"
        className="navbar-gradient d-none d-lg-flex"
      >
        <Container>
          <Navbar.Brand
            onClick={() => navigate('/dashboard')}
            style={{ cursor: 'pointer' }}
            className="d-flex align-items-center"
          >
            <div className="d-flex align-items-center gap-2">
              <img
                src="/Access70Logo.png"
                alt="Access70"
                height="40"
                style={{ maxHeight: '40px', width: 'auto' }}
              />
              <img
                src="/NPI_Logo.png"
                alt="NPI Governance Solutions"
                height="50"
                style={{ maxHeight: '50px', width: 'auto' }}
              />
            </div>
          </Navbar.Brand>
          <Nav className="ms-auto align-items-lg-center">
            <Nav.Link
              onClick={() => navigate('/dashboard')}
              className={isActive('/dashboard') ? 'active' : ''}
            >
              Dashboard
            </Nav.Link>
            <Nav.Link
              onClick={() => navigate('/resources')}
              className={isActive('/resources') ? 'active' : ''}
            >
              Resources
            </Nav.Link>
            <Nav.Link
              onClick={() => navigate('/attendance')}
              className={isActive('/attendance') ? 'active' : ''}
            >
              Attendance
            </Nav.Link>
            <Nav.Link
              onClick={() => navigate('/learner/grades')}
              className={isActive('/learner/grades') ? 'active' : ''}
            >
              Grades
            </Nav.Link>
            <Nav.Link
              onClick={() => navigate('/profile')}
              className={isActive('/profile') ? 'active' : ''}
            >
              Profile
            </Nav.Link>
            <Nav.Link
              onClick={() => navigate('/support')}
              className={isActive('/support') ? 'active' : ''}
            >
              Support
            </Nav.Link>
            <Nav.Link onClick={handleLogout}>
              Logout
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>

      {/* Mobile Header - only visible on mobile */}
      <div className="d-lg-none app-navbar" style={{
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 1040
      }}>
        <div className="d-flex align-items-center gap-2" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
          <img
            src="/Access70Logo.png"
            alt="Access70"
            height="35"
            style={{ maxHeight: '35px', width: 'auto' }}
          />
          <img
            src="/NPI_Logo.png"
            alt="NPI Governance Solutions"
            height="40"
            style={{ maxHeight: '40px', width: 'auto' }}
          />
        </div>
      </div>

      {/* Mobile Bottom Navigation */}
      <LearnerMobileNav />
    </>
  );
};

export default LearnerNavbar;
